import { channelShotNames, ClientSideSidecar } from "@whatslly/types/sidecars-server/Sidecar";
import type { TFunction } from "i18next";

export const sidecarStatusLabel = (sidecar: ClientSideSidecar, t?: TFunction) => {
  if (sidecar.metadata?.isDisconnectedByUser) {
    return t ? t(`sidecars.statuses.disconnected_by_user`) : "disconnected_by_user";
  }
  if (sidecar.metadata?.isPaired) {
    return t ? t(`sidecars.statuses.connected`) : "connected";
  }
  if (sidecar.metadata?.pairingSuccesses && sidecar.metadata?.pairingSuccesses > 0) {
    return t ? t(`sidecars.statuses.not_paired`) : "not_paired";
  }
  return t ? t(`sidecars.statuses.new`) : "new";
};

export const supportedSidecarChannels = Object.keys(channelShotNames) as (keyof typeof channelShotNames)[];
export type SupportedSidecarChannel = (typeof supportedSidecarChannels)[number];
